import {
  API_REQUEST,
  GET_REPORT,
  RESET_REPORT,
} from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction } from "../../types";

export const getReport = (formdata: Record<string, unknown>): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: "/download",
    next: GET_REPORT,
    data: formdata,
    method: "POST",
    authorization: true,
  },
});

export const resetReport = (): AppNoApiAction => ({
  type: RESET_REPORT,
});
